import { z } from 'zod'

import type { NonEmptyArray } from '@mntn-dev/utility-types'

import { EnumBuilder } from '@mntn-dev/utility-types'
import { ModelFilterSchema } from '../model-filter-schema.ts'
import {
  AgencyIdSchema,
  OfferIdSchema,
  OfferUrnSchema,
  ProjectIdSchema,
  UserIdSchema,
} from './unique-id.models.ts'

/**
 * OfferStatus
 */
export const [OfferStatuses, OfferStatusSchema, OfferStatusEnum] = EnumBuilder(
  'accepted',
  'archived',
  'canceled',
  'declined',
  'draft',
  'expired',
  'matched',
  'pending'
)
export type OfferStatus = z.infer<typeof OfferStatusSchema>

export const ActiveOfferStatuses: NonEmptyArray<OfferStatus> = [
  'pending',
  'accepted',
  'matched',
]

export const ViewableOfferStatuses: NonEmptyArray<OfferStatus> = [
  'accepted',
  'archived',
  'canceled',
  'declined',
  'expired',
  'matched',
  'pending',
]

/**
 * OfferDomainSelectModel
 */
export const OfferDomainSelectModelSchema = z.object({
  offerId: OfferIdSchema,
  offerUrn: OfferUrnSchema,
  projectId: ProjectIdSchema,
  acceptorId: UserIdSchema,
  agencyId: AgencyIdSchema,
  status: OfferStatusSchema,
})

export type OfferDomainSelectModel = z.infer<
  typeof OfferDomainSelectModelSchema
>

/**
 * OfferDomainInsertModel
 */
export const OfferDomainInsertModelSchema = OfferDomainSelectModelSchema.omit({
  offerUrn: true,
}).partial({ offerId: true })

export type OfferDomainInsertModel = z.infer<
  typeof OfferDomainInsertModelSchema
>

/**
 * OfferDomainUpdateModel
 */
export const OfferDomainUpdateModelSchema = OfferDomainSelectModelSchema.omit({
  offerId: true,
  offerUrn: true,
}).partial()

export type OfferDomainUpdateModel = z.infer<
  typeof OfferDomainUpdateModelSchema
>

/**
 * OfferDomainSelectModelFilter
 */
export const OfferDomainSelectModelFiltersSchema = z
  .object({
    offerId: ModelFilterSchema(OfferIdSchema),
    offerUrn: ModelFilterSchema(OfferUrnSchema),
    projectId: ModelFilterSchema(ProjectIdSchema),
    acceptorId: ModelFilterSchema(UserIdSchema),
    agencyId: ModelFilterSchema(AgencyIdSchema),
    status: ModelFilterSchema(OfferStatusSchema),
  })
  .partial()

export type OfferDomainSelectModelFilters = z.infer<
  typeof OfferDomainSelectModelFiltersSchema
>
